import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ButtonGroup } from 'components/HookForm';
import When from 'components/When';
import Message from 'components/Message';
import Button from 'components/Button';
import { bem } from 'helpers/class-name';
import appMessages from 'features/App/App.messages';
import { useRegisterFooterFormPresence } from 'features/App/FooterFormPresenceContext';
import { intlMessage } from 'constants/propTypes';
import './FooterForm.scss';

const { block, element } = bem('footer-form');

const FooterForm = ({
  visible,
  submitting,
  desktopNavIsCollapsed,
  submitMessage = appMessages.save,
  cancelMessage = appMessages.cancel,
  deleteMessage = appMessages.delete,
  formName,
  showDelete = false,
  submitDisabled = false,
  onClickCancel = () => {},
  onClickDelete = () => {},
}) => {
  useRegisterFooterFormPresence(visible);

  return ReactDOM.createPortal(
    <ButtonGroup className={block({ visible })}>
      <div className={element('button-container-wrap', { desktopNavIsCollapsed })}>
        <div>
          <When predicate={showDelete}>
            <Message
              as={Button}
              type={Button.TYPES.BUTTON}
              styled="danger"
              message={deleteMessage}
              onClick={onClickDelete}
            />
          </When>
        </div>

        <div>
          <Message
            as={Button}
            type={Button.TYPES.RESET}
            styled="tertiary"
            message={cancelMessage}
            onClick={onClickCancel}
          />
          <Message
            disabled={submitDisabled}
            data-cypress="service-form-submit-button"
            as={Button}
            form={formName}
            type={Button.TYPES.SUBMIT}
            message={submitMessage}
            waiting={submitting}
          />
        </div>
      </div>
    </ButtonGroup>,
    document.body
  );
};

FooterForm.propTypes = {
  visible: PropTypes.bool,
  submitting: PropTypes.bool,
  desktopNavIsCollapsed: PropTypes.bool,
  formName: PropTypes.string,
  submitMessage: intlMessage,
  cancelMessage: intlMessage,
  deleteMessage: intlMessage,
  showDelete: PropTypes.bool,
  submitDisabled: PropTypes.bool,
  onClickCancel: PropTypes.func,
  onClickDelete: PropTypes.func,
};

export default FooterForm;
